<!-- Modal -->
<div class="modal fade" id="modalHabilidades" tabindex="-1" aria-labelledby="modalHabilidadesLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalHabilidadesLabel">
          Habilidades {{softSkill() ? 'Blandas' : 'Técnicas'}}
        </h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row" [formGroup]="form">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Habilidad</label>
              <div>
                <app-dropdown [options]="skills" formControlName="skillId"></app-dropdown>
                @if (form.get('skillId')?.invalid && (form.get('skillId')?.touched || form.get('skillId')?.dirty)) {
                  @if (form.get('skillId')?.errors?.['required'] == true) {
                      <div class="invalid-field">
                          Este campo es requerido
                      </div>
                  }
                }
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Nivel</label>
              <div>
                <app-dropdown [options]="skillLevels" formControlName="skillLevelId" [showSearch]="false"></app-dropdown>
                @if (form.get('skillLevelId')?.invalid && (form.get('skillLevelId')?.touched || form.get('skillLevelId')?.dirty)) {
                  @if (form.get('skillLevelId')?.errors?.['required'] == true) {
                      <div class="invalid-field">
                          Este campo es requerido
                      </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-3 mb-3" />
        <div class="mt-2 mb-2 text-end">
          <button (click)="closeModal()" type="button" class="btn btn-secondary me-2">
            Cancelar
          </button>
          <button (click)="submit()" type="button" class="btn btn-primary">
            @if(!isLoading()){
            Guardar
            }@else {
            <div class="spinner-border spinner-border-sm text-light" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            Guardando
            }
          </button>
        </div>
      </div>
    </div>
  </div>
</div>